<div class="header-label">
  <h2>Adjuster Management</h2>
</div>

<div class="filter-row">

  <mat-form-field appearance="outline" class="search-bar" subscriptSizing="dynamic">
    <mat-label>First Name</mat-label>
    <input matInput [(ngModel)]="filter.firstName" placeholder="Type first name...">
  </mat-form-field>

  <mat-form-field appearance="outline" class="search-bar" subscriptSizing="dynamic">
    <mat-label>Last Name</mat-label>
    <input matInput [(ngModel)]="filter.lastName" placeholder="Type last name...">
  </mat-form-field>

  <mat-form-field appearance="outline" class="search-bar" subscriptSizing="dynamic">
    <mat-label>User Name</mat-label>
    <input matInput [(ngModel)]="filter.userName" placeholder="Type username...">
  </mat-form-field>

  <mat-form-field appearance="outline" class="search-bar" subscriptSizing="dynamic">
    <mat-label>Email</mat-label>
    <input matInput [(ngModel)]="filter.email" placeholder="Type email...">
  </mat-form-field>

  <div class="filter-button-wrap">
    <button mat-flat-button color="primary" (click)="onFilter()">
      Filter
    </button>
  </div>

</div>

<div *ngIf="errorMessage" class="api-error-banner">
  {{ errorMessage }}
</div>

<div class="table-loader" *ngIf="loading">
  <mat-spinner [diameter]="50"></mat-spinner>
</div>

<div class="table-wrapper" [class.loading]="loading">

  <table mat-table [dataSource]="dataSource" matSort [matSortActive]="sortBy" [matSortDirection]="sortDir">

    <ng-container matColumnDef="office">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="office">Office</th>
      <td mat-cell *matCellDef="let row">{{ row.office }}</td>
    </ng-container>

    <ng-container matColumnDef="team">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="team">Team</th>
      <td mat-cell *matCellDef="let row">{{ row.team }}</td>
    </ng-container>

    <ng-container matColumnDef="firstName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="firstName">First Name</th>
      <td mat-cell *matCellDef="let row">{{ row.firstName }}</td>
    </ng-container>

    <ng-container matColumnDef="lastName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="lastName">Last Name</th>
      <td mat-cell *matCellDef="let row">{{ row.lastName }}</td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="email">Email</th>
      <td mat-cell *matCellDef="let row">{{ row.email }}</td>
    </ng-container>

    <ng-container matColumnDef="adjusterKey">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="adjusterKey">Key</th>
      <td mat-cell *matCellDef="let row">{{ row.adjusterKey }}</td>
    </ng-container>

    <ng-container matColumnDef="userName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="userName">User Name</th>
      <td mat-cell *matCellDef="let row">{{ row.userName }}</td>
    </ng-container>

    <ng-container matColumnDef="telephone">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="telephone">Telephone</th>
      <td mat-cell *matCellDef="let row">{{ row.telephone }}</td>
    </ng-container>

    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef class="no-header"></th>
      <td mat-cell *matCellDef="let row" class="actions-cell">
        <button class="table-action-btn" mat-icon-button (click)="onDelete(row)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

  </table>

  <div *ngIf="dataSource.data.length === 0" class="no-results-message">
    No adjusters found
  </div>

</div>

<mat-paginator
  [length]="totalCount"
  [pageIndex]="pageIndex"
  [pageSize]="pageSize"
  [pageSizeOptions]="[10, 20, 50]"
  (page)="onPageChange($event)"
  showFirstLastButtons>
</mat-paginator>